<template>
  <form style="overflow: hidden;">
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
        <slot name="back-button">
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="cancelTable" v-if="!fromExternal">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </slot>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="!isNew" @click.prevent="deleteTable" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-icon btn-success btn mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch; flex-wrap: wrap;">
      <div class="col-lg-12 col-md-12">
        <div :class="model.type === 'Kiosk' ? 'card' : ''" style="width:100%; position: relative;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div :class="model.type === 'Kiosk' ? 'card-content' : ''">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div class="row qr-settings-grid">
                  <div :class="model.type !== 'Kiosk' ? 'col-md-6 qr-card-column' : 'col-md-12'">
                    <div class="qr-card-slot">
                      <div :class="model.type !== 'Kiosk' ? 'card' : ''" data-qr-section="general">
                        <div class="card-header" v-if="model.type !== 'Kiosk'">
                          <h4 class="card-title">{{ $t('settingTable.qrGeneralSettings') }}</h4>
                        </div>
                        <div :class="model.type !== 'Kiosk' ? 'card-content' : ''">
                          <div class="form-group">
                            <p>ID: {{model.id}}</p>
                          </div>
                          <div class="form-group" v-show="model.table_colors_string">
                            <label>Colors</label>
                            <input type="text"
                                    name="table_colors_string"
                                    data-vv-as="table_colors_string"
                                    placeholder="Colors"
                                    v-validate="modelValidate.table_colors_string"
                                    v-model="model.table_colors_string"
                                    class="form-control">
                            <small class="text-danger" v-if="errors.has('table_colors_string')">
                              {{ getError('table_colors_string') }}
                            </small>
                          </div>
                          <div class="form-group">
                            <label>{{$t('settingTable.location')}}</label>
                            <select name="location" class="form-control"
                                          v-validate="modelValidate.location_id"
                                          v-model="model.location_id"
                                          :disabled="autoselectLocation ? true : false"
                                          >
                              <option v-for="(loc) in locations"
                                          :value="loc.true_id"
                                          :label="loc.name"
                                          :key="loc.true_id">
                              </option>
                            </select>
                            <small class="text-danger" v-show="type.invalid">
                              {{ getError('type') }}
                            </small>
                          </div>
                          <div class="form-group">
                            <label>{{$t('settingTable.type')}}</label>
                            <select name="type" class="form-control"
                                          v-validate="modelValidate.type"
                                          v-model="model.type"
                                          >
                              <option v-for="t in type"
                                          :value="t"
                                          :label="t"
                                          :key="t">
                              </option>
                            </select>
                            <small class="text-danger" v-show="type.invalid">
                              {{ getError('type') }}
                            </small>
                          </div>
                          <div class="form-group" v-if="model.type != 'Kiosk'">
                            <label>{{$t('settingTable.table_shape')}}</label>
                            <select name="type" class="form-control"
                                          v-validate="modelValidate.table_shape"
                                          v-model="model.table_shape"
                                          >
                              <option selected value="squere" :label="$t('settingTable.squere')" key="squere"> </option>
                              <option value="round" :label="$t('settingTable.round')" key="round"> </option>
                            </select>
                            <small class="text-danger" v-show="type.invalid">
                              {{ getError('type') }}
                            </small>
                          </div>
                          <div class="form-group">
                            <label>{{$t('settingTable.zone')}}</label>
                            <select name="zone" class="form-control"
                                          v-validate="modelValidate.zone"
                                          v-model="model.table_zones_id"
                                          >
                              <option v-for="z in zone"
                                          :value="z.id"
                                          :label="z.name"
                                          :key="z.id">
                              </option>
                            </select>
                            <small class="text-danger" v-show="zone.invalid">
                              {{ getError('zone') }}
                            </small>
                          </div>
                          <div class="form-group">
                            <label>{{ model.type == 'Kiosk' ? $t('settingTable.kioskName') : $t('settingTable.number', {type: model.type}) }}</label>
                            <input type="text"
                                    name="number"
                                    :data-vv-as="model.type == 'Kiosk' ? 'name' : 'number'"
                                    :placeholder="model.type == 'Kiosk' ? $t('settingTable.kioskName') : $t('settingTable.number')"
                                    v-validate="modelValidate.number"
                                    v-model="model.number"
                                    class="form-control">
                            <small class="text-danger" v-if="errors.has('number')">
                              {{ getError('number') }}
                            </small>
                          </div>
                          <div class="form-group">
                            <label>{{$t('settingTable.externalId')}}</label>
                            <input type="text"
                                    name="external_id"
                                    data-vv-as="external_id"
                                    :placeholder="$t('settingTable.externalIdPlaceholder')"
                                    v-model="model.external_id"
                                    class="form-control">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="qr-card-slot" v-if="model.type !== 'Kiosk'">
                      <div class="card" data-qr-section="capacity">
                        <div class="card-header">
                          <h4 class="card-title">{{ $t('settingTable.qrCapacitySettings') }}</h4>
                        </div>
                        <div class="card-content">
                          <div class="form-group" v-if="model.type != 'Kiosk'">
                            <p-checkbox
                              v-model="model.app_available"
                              key="use_fiscal_net"
                              :label="$t('settingTable.app_available')"
                              :inline="true"
                            >{{$t('settingTable.app_available')}}
                            </p-checkbox>
                          </div>
                          <div class="form-group" v-if="model.type != 'Kiosk'">
                            <label>{{$t('settingTable.min_pers')}}</label>
                            <input type="number"
                                    min="1"
                                    max="30"
                                    name="min_pers"
                                    data-vv-as="min_pers"
                                    v-validate="modelValidate.min_pers"
                                    v-model="model.min_pers"
                                    class="form-control">
                            <small class="text-danger" v-if="errors.has('min_pers')">
                              {{ getError('min_pers') }}
                            </small>
                          </div>
                          <div class="form-group" v-if="model.type != 'Kiosk'">
                            <label>{{$t('settingTable.max_pers')}}</label>
                            <input type="number"
                                    min="1"
                                    max="30"
                                    name="max_pers"
                                    data-vv-as="max_pers"
                                    v-validate="modelValidate.max_pers"
                                    v-model="model.max_pers"
                                    class="form-control">
                            <small class="text-danger" v-if="errors.has('max_pers')">
                              {{ getError('max_pers') }}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="qr-card-slot" v-if="model.type !== 'Kiosk' && model.qr_offline">
                      <div class="card" data-qr-section="numbering">
                        <div class="card-header">
                          <h4 class="card-title">{{ $t('settingTable.qrNumberingSettings') }}</h4>
                        </div>
                        <div class="card-content">
                          <div class="row" v-if="model.qr_offline">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>{{$t('settingTable.series')}}</label>
                                <input
                                  type="text"
                                  name="series"
                                  :placeholder="$t('settingTable.series')"
                                  v-validate="modelValidate.series"
                                  v-model="model.series"
                                  class="form-control">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>{{$t('settingTable.start_number')}}</label>
                                <input
                                  type="number"
                                  name="start_number"
                                  :placeholder="$t('settingTable.start_number')"
                                  v-validate="modelValidate.start_number"
                                  v-model="model.start_number"
                                  class="form-control">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 qr-card-column" v-if="model.type !== 'Kiosk'">
                    <div class="qr-card-slot" v-if="model.type !== 'Kiosk'">
                      <div class="card" data-qr-section="connection">
                        <div class="card-header">
                          <h4 class="card-title">{{ $t('settingTable.qrConnectionSettings') }}</h4>
                        </div>
                        <div class="card-content">
                          <div class="form-group" v-if="model.type !== 'Kiosk'">
                            <p-checkbox
                              v-model="model.qr_offline"
                              key="qr_offline"
                              :label="$t('settingTable.qr_offline')"
                              :inline="true"
                            >{{$t('settingTable.qr_offline')}}</p-checkbox>
                            <p v-if="model.qr_offline && model.id" style="margin: 8px 0 0;">
                              {{$t('settingTable.offlineLoginCode')}} {{model.company_id || company_id}}.{{model.id}}
                            </p>
                            <div v-if="offlineUrl && model.type !== 'Kiosk'" class="offline-url">
                              <input type="text" class="form-control" readonly :value="offlineUrl" aria-label="Offline URL" @click="$event.target.select()">
                              <button type="button" class="btn btn-purple btn-fill" @click="copyToClipboard(offlineUrl)">
                                <i class="fa fa-copy" aria-hidden="true"></i> {{$t('general.copyUrlToClipboard')}}
                              </button>
                            </div>
                          </div>
                          <div class="form-group" v-if="model.qr_offline">
                            <label>{{$t('settingTable.server_ip')}}</label>
                            <input type="text"
                                   name="server_pos_ip"
                                   :placeholder="$t('settingTable.server_ip')"
                                   v-model="model.server_pos_ip"
                                   v-validate="model.type !== 'Kiosk' && model.qr_offline ? 'required' : ''"
                                   :data-vv-as="$t('settingTable.server_ip')"
                                   class="form-control">
                            <small class="text-danger" v-if="errors.has('server_pos_ip')">{{ getError('server_pos_ip') }}</small>
                          </div>
                          <div class="form-group mar-to-15" v-if="model.qr_offline">
                            <label>{{$t('settingTable.yumm_integration_external_ip')}}</label>
                            <input type="text"
                                   name="yumm_integration_external_ip"
                                   placeholder="Ip"
                                   v-model="model.yumm_integration_external_ip"
                                   class="form-control"
                                   style="max-width: 280px;">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="qr-card-slot" v-if="model.type !== 'Kiosk'">
                      <div class="card" data-qr-section="service">
                        <div class="card-header">
                          <h4 class="card-title">{{ $t('settingTable.qrServiceSettings') }}</h4>
                        </div>
                        <div class="card-content">
                          <div class="form-group" v-if="model.qr_offline">
                            <label>{{ $t('settingTable.qrServiceCode') }}</label>
                            <input type="text" name="login_code" maxlength="191"
                                   v-model="model.login_code" class="form-control">
                            <small class="text-danger" v-if="errors.has('login_code')">{{ getError('login_code') }}</small>
                          </div>
                          <div class="form-group" v-if="model.type != 'Kiosk'">
                            <label>{{$t('settingTable.waiters')}}</label>
                            <el-select v-model="selectedWaiterIds"
                                       multiple filterable
                                       class="qr-waiter-select"
                                       :class="{'has-overflow': selectedWaiterIds.length > 3}"
                                       :placeholder="$t('settingTable.assignWaiter')"
                                       :style="waiterSelectStyle">
                              <el-option v-for="user in waiterOptions"
                                         :key="user.id"
                                         :label="user.fullname"
                                         :value="user.id" />
                            </el-select>

                            <small class="text-danger" v-if="errors.has('users')">
                              {{ getError('users') }}
                            </small>
                          </div>

                        </div>
                      </div>
                    </div>
                          <div class="qr-preview" v-if="model.id">
                      <div class="card" style=" width:100%; margin: 0;">
                        <div class="card-content" style=" width:100%; margin: 0;">
                          <div class="middle" style=" width:100%;">
                            <img :src="model.qr_code" alt="qrCode" :data-link="model.qr_link" @click="copyToClipboard(model.qr_link)">
                            <a class="btn btn-info btn-icon duplicate-prod mar-to-15"
                            :href="this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + model.qr_code + '&name=' + model.type + ' ' + model.number + '.png'"
                            target="_blank">{{$t('upload.download')}}</a>
                            <input class="copy_link" type="text" @click="copyToClipboard(model.qr_link)" disabled=true :value="model.qr_link">

                            <template v-if="model.type == 'Kiosk'">
                              <br />
                              <div style="display: flex; align-items: center; justify-content: center;">
                                <p style="margin: 0; min-width: 110px;">{{$t('settingTable.loginCode')}}</p>
                                <input style="margin: 0;" class="copy_link" type="text" @click="copyToClipboard(model.login_code)" disabled=true :value="model.login_code">
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" v-if="model.type !== 'Kiosk'">
                    <qr-payment-settings v-if="model.type !== 'Kiosk'"
                    v-model="model.qr_payment_methods"
                    :pos-options="qrPosOptions"
                    :legacy-bank-provider="model.bank_terminal_provider || (model.with_viva_wallet ? 'viva_wallet' : null)"
                    :error-bag="errors" />
                  </div>
                  <div class="col-md-12" v-if="model.type === 'Kiosk'">
                    <div class="form-group" v-if="model.type == 'Kiosk'">
                      <p-checkbox
                        v-model="model.kiosk_offline"
                        key="kiosk_offline"
                        :label="$t('settingTable.kiosk_offline')"
                        :inline="true"
                      >{{$t('settingTable.kiosk_offline')}}
                      </p-checkbox>
                      <p v-if="model.kiosk_offline && model.id" style="margin: 8px 0 0;">
                        {{$t('settingTable.offlineLoginCode')}} {{model.company_id || company_id}}.{{model.id}}
                      </p>
                      <div v-if="offlineUrl && model.type === 'Kiosk'" class="offline-url">
                        <input type="text" class="form-control" disabled :value="offlineUrl" aria-label="Offline URL">
                        <button type="button" class="btn btn-purple btn-fill" @click="copyToClipboard(offlineUrl)">
                          <i class="fa fa-copy" aria-hidden="true"></i> {{$t('general.copyUrlToClipboard')}}
                        </button>
                      </div>
                    </div>
                    <kiosk-video-input v-if="model.type === 'Kiosk'"
                      v-model="model.videos"
                      :company-id="model.company_id || company_id"
                      :location-id="model.location_id"
                      :table-id="model.id || null" />
                    <div class="form-group" v-if="model.type === 'Kiosk'">
                      <label for="kiosk-ga4-code">{{$t('settingsWeb.g4a')}}</label>
                      <input id="kiosk-ga4-code"
                             type="text"
                             name="ga4Code"
                             placeholder="G-XXXXXXXXXX"
                             maxlength="255"
                             v-model="model.ga4Code"
                             class="form-control">
                      <small class="text-danger" v-if="errors.has('ga4Code')">
                        {{ getError('ga4Code') }}
                      </small>
                    </div>
                    <div class="form-group" v-if="model.type === 'Kiosk'">
                      <label>{{$t('settingTable.server_ip')}}</label>
                      <input type="text"
                             name="server_pos_ip"
                             :placeholder="$t('settingTable.server_ip')"
                             v-model="model.server_pos_ip"
                             v-validate="model.type !== 'Kiosk' && model.qr_offline ? 'required' : ''"
                             :data-vv-as="$t('settingTable.server_ip')"
                             class="form-control">
                      <small class="text-danger" v-if="errors.has('server_pos_ip')">{{ getError('server_pos_ip') }}</small>
                    </div>
                    <div class="form-group mar-to-15" v-if="model.type === 'Kiosk'">
                      <label>{{$t('settingTable.yumm_integration_external_ip')}}</label>
                      <input type="text"
                             name="yumm_integration_external_ip"
                             placeholder="Ip"
                             v-model="model.yumm_integration_external_ip"
                             class="form-control"
                             style="max-width: 280px;">
                    </div>
                    <div class="form-group" v-if="model.type == 'Kiosk'">
                      <label>Scaner Position</label>
                      <select name="scaner_position" class="form-control"
                              v-model="model.scaner_position"
                              >
                        <option value="left" label="Left" key="left"></option>
                        <option value="center" label="Center" key="center"></option>
                        <option value="right" label="Right" key="right"></option>
                      </select>
                    </div>
                    <div class="row" v-if="model.type === 'Kiosk' || model.qr_offline">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>{{$t('settingTable.series')}}</label>
                          <input
                            type="text"
                            name="series"
                            :placeholder="$t('settingTable.series')"
                            v-validate="modelValidate.series"
                            v-model="model.series"
                            class="form-control">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>{{$t('settingTable.start_number')}}</label>
                          <input
                            type="number"
                            name="start_number"
                            :placeholder="$t('settingTable.start_number')"
                            v-validate="modelValidate.start_number"
                            v-model="model.start_number"
                            class="form-control">
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-if="model.type == 'Kiosk'">
                      <label>{{$t('settingTable.kioskUrl')}}</label>
                      <input type="text"
                             name="kioskUrl"
                             disabled="true"
                             v-model="kioskUrl"
                             class="form-control">
                    </div>
                    <div class="form-group" v-if="model.type == 'Kiosk'">
                      <p-checkbox
                        class="margin-left-10"
                        v-model="model.use_fiscal_net"
                        key="use_fiscal_net"
                        :label="$t('settingTable.use_fiscal_net')"
                        :inline="true"
                      >{{$t('settingTable.use_fiscal_net')}}
                      </p-checkbox>
                      <p-checkbox
                        class="margin-left-10"
                        v-model="model.use_fiscal_net_with_pos"
                        key="use_fiscal_net_with_pos"
                        :label="$t('settingTable.use_fiscal_net_with_pos')"
                        :inline="true"
                      >{{$t('settingTable.use_fiscal_net_with_pos')}}
                      </p-checkbox>
                      <p-checkbox
                        class="margin-left-10"
                        v-model="model.use_pager"
                        key="use_pager"
                        :label="$t('settingTable.use_pager')"
                        :inline="true"
                      >{{$t('settingTable.use_pager')}}
                      </p-checkbox>
                      <p-checkbox
                        class="margin-left-10"
                        v-model="model.use_cash_machine"
                        key="use_cash_machine"
                        :label="$t('settingTable.use_cash_machine')"
                        :inline="true"
                      >{{$t('settingTable.use_cash_machine')}}
                      </p-checkbox>
                      <p-checkbox
                        class="margin-left-10"
                        v-model="model.disable_cash_payment"
                        key="disable_cash_payment"
                        :label="$t('settingTable.disable_cash_payment')"
                        :inline="true"
                      >{{$t('settingTable.disable_cash_payment')}}
                      </p-checkbox>
                      <br>
                      <p-checkbox
                        class="margin-left-10"
                        v-model="model.kiosk_is_using_fiscal_receipt_for_sections"
                        key="kiosk_is_using_fiscal_receipt_for_sections"
                        :label="$t('settingTable.kiosk_is_using_fiscal_receipt_for_sections')"
                        :inline="true"
                      >{{$t('settingTable.kiosk_is_using_fiscal_receipt_for_sections')}}
                      </p-checkbox>
                      <br>
                      <p-checkbox
                        class="margin-left-10"
                        v-model="model.use_tips"
                        key="use_tips"
                        :label="$t('settingTable.use_tips')"
                        :inline="true"
                      >{{$t('settingTable.use_tips')}}
                      </p-checkbox>
                      <br>
                      <p-checkbox
                        class="margin-left-10"
                        v-model="model.use_methods"
                        key="use_methods"
                        :label="$t('settingTable.use_methods')"
                        :inline="true"
                      >{{$t('settingTable.use_methods')}}
                      </p-checkbox>
                    </div>
                    <div class="form-group" v-if="model.type == 'Kiosk' && model.use_fiscal_net">
                      <div class="form-group">
                      <label>Fiscal Printer</label>
                        <!-- v-validate="modelValidate.fiscal_printer_id" -->
                      <select
                        name="location"
                        class="form-control"
                        v-model="model.fiscal_printer_id"
                      >
                        <option :value="null" >{{$t('general.none')}}</option>
                        <option
                          v-for="(el) in fiscalPrinter"
                          :value="el.id"
                          :label="el.series"
                          :key="el.id">
                        </option>
                      </select>
                    </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>


        </div>
      </div>
      <div class="col-lg-6 col-md-12" v-if="model.id && model.type === 'Kiosk' && !model.kiosk_offline">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div class="card-content" style="height:100%; width:100%; margin: 0;">
            <div class="middle" style="height:100%; width:100%;">
              <img :src="model.qr_code" alt="qrCode" :data-link="model.qr_link" @click="copyToClipboard(model.qr_link)">
              <a class="btn btn-info btn-icon duplicate-prod mar-to-15"
              :href="this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + model.qr_code + '&name=' + model.type + ' ' + model.number + '.png'"
              target="_blank">{{$t('upload.download')}}</a>
              <input class="copy_link" type="text" @click="copyToClipboard(model.qr_link)" disabled=true :value="model.qr_link">

              <template v-if="model.type == 'Kiosk'">
                <br />
                <div style="display: flex; align-items: center; justify-content: center;">
                  <p style="margin: 0; min-width: 110px;">{{$t('settingTable.loginCode')}}</p>
                  <input style="margin: 0;" class="copy_link" type="text" @click="copyToClipboard(model.login_code)" disabled=true :value="model.login_code">
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Online-ordering QR: shown ONLY in the QR menu (Qr.vue sets showOnlineQr),
         never on the table maps view (PosMapForm loads the same form). -->
    <div class="row mar-to-15" style="margin-top: 30px;" v-if="model.id && showOnlineQr">
      <div class="col-lg-6 col-md-12">
        <div class="card" style="margin: 0;">
          <div class="card-content" style="position: relative;">
            <div :class="(onlineQrLoading ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg>
              </div>
            </div>

            <h4 style="margin: 0 0 4px; font-weight: 600;">{{$t('settingTable.onlineQrTitle')}}</h4>
            <p style="margin: 0 0 20px; color: #9a9a9a; font-size: 13px;">{{$t('settingTable.onlineQrDesc')}}</p>

            <div v-if="model.online_qr_token" style="text-align: center;">
              <img :src="onlineQrImage" alt="onlineQrCode"
                   style="width: 200px; height: 200px; max-width: 100%; cursor: pointer; border: 1px solid #eee; border-radius: 8px; padding: 6px;"
                   @click="copyToClipboard(onlineQrLink)">

              <div style="display: flex; align-items: center; gap: 8px; margin: 16px auto 0; max-width: 380px;">
                <input class="form-control" type="text" readonly :value="onlineQrLink"
                       style="flex: 1; font-size: 12px; cursor: pointer;" @click="copyToClipboard(onlineQrLink)">
                <a class="btn btn-info btn-icon" style="margin: 0; white-space: nowrap;" @click.prevent="copyToClipboard(onlineQrLink)">
                  {{$t('settingTable.onlineQrCopy')}}
                </a>
              </div>

              <div style="margin-top: 16px; display: flex; gap: 8px; justify-content: center; flex-wrap: wrap;">
                <a class="btn btn-orange btn-icon" style="margin: 0;" @click.prevent="generateOnlineQr">
                  {{$t('settingTable.onlineQrRegenerate')}}
                </a>
                <a class="btn btn-info btn-icon" style="margin: 0;"
                   :href="apiUrl + '/settings/download?token=' + $session.get('token') + '&url=' + onlineQrImage + '&name=online ' + model.type + ' ' + model.number + '.png'"
                   target="_blank">{{$t('upload.download')}}</a>
              </div>
            </div>

            <div v-else style="text-align: center; padding: 24px 0;">
              <p style="color: #9a9a9a; margin-bottom: 20px;">{{$t('settingTable.onlineQrEmpty')}}</p>
              <a class="btn btn-orange btn-icon" style="margin: 0;" @click.prevent="generateOnlineQr">
                {{$t('settingTable.onlineQrGenerate')}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch; margin-top: 30px;">
      <div class="col-lg-6 col-md-12" v-if="model.type == 'Kiosk'">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div class="card-content" style="height:100%; width:100%; margin: 0;">
            <h3 style="margin-top: 0;">{{$t('settingTable.posSet')}}</h3>
            <div class="form-group">
              <label>{{$t('settingTable.type')}}</label>
              <select name="pos" class="form-control"
                            v-model="model.pos"
                            >
                <option :value="null"
                        :label="''"
                        :key="0"></option>
                <option v-for="z in pos"
                            :value="(model.pos && z.id == model.pos.id) ? model.pos : z"
                            :label="z.name"
                            :key="z.id">
                </option>
              </select>
            </div>
            <template v-if="model.pos">
              <div class="form-group" v-if="isVivaWalletPos">
                <label>{{ $t('settingTable.host') }}</label>
                <input
                  type="text"
                  name="model.pos.host"
                  data-vv-as="model.pos.host"
                  :placeholder="$t('settingTable.host')"
                  v-model="model.pos.host"
                  class="form-control"
                >
              </div>
              <div class="form-group" v-else-if="typeof model.pos.ip !== 'undefined' && model.pos.ip != null">
                <label>{{$t('settingTable.ip')}}</label>
                <input type="text"
                        name="model.pos.ip"
                        data-vv-as="model.pos.ip"
                        :placeholder="$t('settingTable.ip')"
                        v-model="model.pos.ip"
                        class="form-control">
              </div>
              <div class="form-group" v-if="typeof model.pos.port !== 'undefined' && model.pos.port != null">
                <label>{{$t('settingTable.terminal_port')}}</label>
                <input type="text"
                        name="model.pos.port"
                        data-vv-as="model.pos.port"
                        :placeholder="$t('settingTable.terminal_port')"
                        v-model="model.pos.port"
                        class="form-control">
              </div>
              <div class="form-group" v-if="hasPosServerFields">
                <label>{{$t('settingTable.server_ip')}}</label>
                <input type="text"
                        name="model.pos.server_ip"
                        data-vv-as="model.pos.server_ip"
                        :placeholder="$t('settingTable.server_ip')"
                        v-model="model.pos.server_ip"
                        class="form-control">
              </div>
              <div class="form-group" v-if="hasPosServerFields">
                <label>{{$t('settingTable.server_port')}}</label>
                <input type="text"
                        name="model.pos.server_port"
                        data-vv-as="model.pos.server_port"
                        :placeholder="$t('settingTable.server_port')"
                        v-model="model.pos.server_port"
                        class="form-control">
              </div>
              <div class="form-group" v-if="typeof model.pos.tid_mid !== 'undefined' && model.pos.tid_mid != null">
                <label>TID/MID</label>
                <input type="text"
                        name="TID/MID"
                        data-vv-as="model.pos.tid_mid"
                        placeholder="TID/MID"
                        v-model="model.pos.tid_mid"
                        class="form-control">
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12" v-if="model.type == 'Kiosk'">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div class="card-content" style="height:100%; width:100%; margin: 0;">
            <h3 style="margin-top: 0;">{{$t('settingTable.printerSet')}}</h3>
            <div class="form-group">
              <label>{{$t('settingTable.type')}}</label>
              <select name="printer" class="form-control"
                            v-validate="modelValidate.printer"
                            v-model="model.printer"
                            >
                <option :value="null"
                        :label="''"
                        :key="0"></option>
                <option v-for="z in printer"
                            :value="(model.printer && z.id == model.printer.id) ? model.printer : z"
                            :label="z.name"
                            :key="z.id">
                </option>
              </select>
              <small class="text-danger" v-show="printer.invalid">
                {{ getError('printer') }}
              </small>
            </div>
            <template v-if="model.printer">
              <div class="form-group" v-if="typeof model.printer.p1 !== 'undefined'">
                <label>{{$t('settingTable.p1')}}</label>
                <input type="text"
                        name="model.printer.p1"
                        data-vv-as="model.printer.p1"
                        :placeholder="$t('settingTable.p1')"
                        v-model="model.printer.p1"
                        class="form-control">
              </div>
              <div class="form-group" v-if="typeof model.printer.p2 !== 'undefined'">
                <label>{{$t('settingTable.p2')}}</label>
                <input type="text"
                        name="model.printer.p2"
                        data-vv-as="model.printer.p2"
                        :placeholder="$t('settingTable.p2')"
                        v-model="model.printer.p2"
                        class="form-control">
              </div>

              <div class="form-group" v-if="typeof model.printer.ip !== 'undefined'">
                <label>{{$t('settingTable.ip')}}</label>
                <input type="text"
                        name="model.printer.ip"
                        data-vv-as="model.printer.ip"
                        :placeholder="$t('settingTable.ip')"
                        v-model="model.printer.ip"
                        class="form-control">
              </div>
              <div class="form-group" v-if="typeof model.printer.port !== 'undefined'">
                <label>{{$t('settingTable.port')}}</label>
                <input type="text"
                        name="model.printer.port"
                        data-vv-as="model.printer.port"
                        :placeholder="$t('settingTable.port')"
                        v-model="model.printer.port"
                        class="form-control">
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12" v-if="model.type == 'Kiosk'">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div class="card-content" style="height:100%; width:100%; margin: 0;">
            <h3 style="margin-top: 0;">{{$t('settingTable.fiscalSet')}}</h3>
            <div class="form-group">
              <label>{{$t('settingTable.type')}}</label>
              <select name="fiscal" class="form-control"
                            v-model="model.fiscal"
                            >
                <option :value="null"
                        :label="''"
                        :key="0"></option>
                <option v-for="z in fiscal"
                            :value="(model.fiscal && z.id == model.fiscal.id) ? model.fiscal : z"
                            :label="z.name"
                            :key="z.id">
                </option>
              </select>
            </div>
            <template v-if="model.fiscal">
              <div class="form-group" v-if="typeof model.fiscal.port !== 'undefined' && model.fiscal.port != null">
                <label>{{$t('settingTable.port')}}</label>
                <input type="text"
                        name="model.fiscal.port"
                        data-vv-as="model.fiscal.port"
                        :placeholder="$t('settingTable.port')"
                        v-model="model.fiscal.port"
                        class="form-control">
              </div>
              <template v-if="model.fiscal.id == 1">
                <p>DataBits: 8</p>
                <p>Parity: 'none'</p>
                <p>StopBits: 1</p>
                <p>BaudRate: 115200</p>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>

  </form>
</template>
<script>
  import Vue from 'vue'
  import {Input, Upload, Button, DatePicker, Select, Option} from 'element-ui'
  import QrPaymentSettings from './QrPaymentSettings.vue'
  import KioskVideoInput from 'src/components/UIComponents/Inputs/KioskVideoInput.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      QrPaymentSettings,
      KioskVideoInput,
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      autoselectLocation: null,
      posUsers: {
        required: false,
        type: Array,
        default: () => []
      },
      fromExternal: null,
      tableId: null,
      // Only the QR menu (Qr.vue) passes this; the table maps view (PosMapForm)
      // loads the same form but must NOT show the online-QR box.
      showOnlineQr: {
        required: false,
        type: Boolean,
        default: false
      },
      callback: {
        required: false
      }
    },
    watch: {
      tableId (value) {
        this.id = value
      }
    },
    created () {
      this.company_id = this.$session.get('selectedCompany')
      if (this.autoselectLocation) {
        this.model.location_id = this.autoselectLocation
      }
      this.apiUrl = process.env.API_BASE_URL
      this.getData()
      this.setAvailableTypes()
    },
    computed: {
      offlineUrl () {
        const isKiosk = this.model.type === 'Kiosk'
        const isOffline = isKiosk ? this.model.kiosk_offline : this.model.qr_offline
        const companyId = this.model.company_id || this.company_id
        if (!isOffline || !companyId || !this.model.id) return ''
        const baseUrl = isKiosk ? 'https://kioskoffline.taptasty.ro?auth=' : 'https://qrofflinelive.taptasty.ro?qr='
        return baseUrl + encodeURIComponent(`${companyId}.${this.model.id}`)
      },
      waiterSelectStyle () {
        return {
          width: '100%',
          '--waiter-overflow-label': JSON.stringify('+ ' + Math.max(0, this.selectedWaiterIds.length - 3))
        }
      },
      selectedWaiterIds: {
        get () {
          return (this.model.users || []).map(user => user.user_id || user.id)
        },
        set (ids) {
          const existing = this.model.users || []
          this.$set(this.model, 'users', ids.map(id => {
            return existing.find(user => (user.user_id || user.id) === id) ||
              this.posUsersFiltered.find(user => user.id === id)
          }).filter(Boolean))
        }
      },
      waiterOptions () {
        const options = this.posUsersFiltered.slice()
        ;(this.model.users || []).forEach(user => {
          const id = user.user_id || user.id
          if (!options.some(option => option.id === id)) {
            options.push({id, fullname: user.fullname})
          }
        })
        return options
      },
      qrPosOptions () {
        return Object.values(this.pos)
      },
      isVivaWalletPos () {
        return this.model.pos && Number(this.model.pos.id) === 4
      },
      // BT (1), UniCredit (2), Raiffeisen (3): server ip/port optional, saved in pos json only when filled
      isOptionalServerPos () {
        return this.model.pos && [1, 2, 3].includes(Number(this.model.pos.id))
      },
      hasPosServerFields () {
        return this.isVivaWalletPos || this.isOptionalServerPos
      },
      hasBankTerminalProvider () {
        return !!this.model.bank_terminal_provider
      },
      posUsersFiltered () {
        return this.posUsers.filter(user => {
          // daca nu are location_details sau e gol ramane in lista
          if (!user.location_details || user.location_details.length === 0) {
            return true
          }

          return user.location_details.includes(this.model.location_id)
        })
      },
      // online_qr_code stores only the file name; prefix the domain from env here.
      onlineQrImage () {
        if (!this.model.online_qr_code) return ''
        return /^https?:\/\//.test(this.model.online_qr_code)
          ? this.model.online_qr_code
          : (this.apiUrl + '/images/' + this.model.online_qr_code)
      },
      // Shareable link = the API redirect route (domain-change proof).
      onlineQrLink () {
        return this.model.online_qr_token
          ? (this.apiUrl + '/table-online/' + this.model.online_qr_token)
          : ''
      }
    },
    data () {
      return {
        apiUrl: '',
        company_id: null,
        roles: [],
        id: this.tableId,
        isNew: true,
        kioskUrl: 'https://live.taptasty.com/kiosk-nodejs/KioskApp.zip',
        filelist: [],
        fiscalPrinter: [],
        bankTerminalProviders: [
          { value: 'viva_wallet', label: 'Viva Wallet' },
          { value: 'banca_transilvania', label: 'Banca Transilvania' }
        ],
        model: {
          'id': 0,
          'current_order_id': null,
          'location_id': '',
          'number': '',
          'external_id': '',
          'ga4Code': null,
          'qr_offline': false,
          'offline_pairing_code': null,
          'qr_payment_methods': null,
          'login_code': null,
          'kiosk_offline': false,
          'videos': [],
          'server_pos_ip': null,
          'yumm_integration_external_ip': '',
          'series': null,
          'start_number': null,
          'qr_link': '',
          'online_qr_token': '',
          'online_qr_code': '',
          'type': 'Masa',
          'scaner_position': 'left',
          'with_viva_wallet': false,
          'bank_terminal_provider': null,
          'bank_terminal_data': {
            merchantId: '',
            terminalId: '',
            activationCode: ''
          },
          'zone': '',
          'table_shape': 'squere',
          'user_id': 0
        },
        // zone: ['Restaurant', 'Terasa', 'Plaja', 'Hotel', 'Cafenea', 'Vip'],
        zone: [],
        type: ['Masa', 'Umbrela', 'Camera', 'Kiosk'],
        printer: {
          1: {
            'id': 1,
            'name': 'Network',
            'ip': '',
            'port': ''
          },
          2: {
            'id': 2,
            'name': 'USB',
            'p1': '',
            'p2': ''
          }
        },
        pos: {
          1: {
            'id': 1,
            'name': 'Ingenico 3200 (bt)',
            'ip': '',
            'port': '',
            'tid_mid': ''
          },
          2: {
            'id': 2,
            'name': 'Ingenico 3200 (unicredit)',
            'ip': null,
            'port': '',
            'tid_mid': ''
          },
          3: {
            'id': 3,
            'name': 'Ingenico 3200 (raiffeisen)',
            'ip': null,
            'port': '',
            'tid_mid': ''
          },
          4: {
            'id': 4,
            'name': 'Viva Wallet',
            'host': '',
            'port': '',
            'server_ip': '',
            'server_port': '',
            'tid_mid': ''
          }
        },
        fiscal: {
          1: {
            'id': 1,
            'name': 'Datex FP800',
            'port': ''
          }
        },
        locations: [],
        driverCode: '',
        modelValidate: {
          type: {required: true},
          zone: {required: true},
          number: {required: true},
          min_pers: {required: true, min: 1, max: 30},
          max_pers: {required: true, min: 1, max: 30}
          // firstname: {required: true, min: 3},
        },
        languages: this.$session.get('defaultData')['available_languages'],
        loading: true,
        onlineQrLoading: false
      }
    },
    methods: {
      updateWoltMenu () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          wolt_company_id: this.location.wolt_company_id
        }
        this.apiRequest('/wolt/export-menu', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      handleWoltStatus () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          wolt_company_id: this.location.wolt_company_id,
          active: this.woltStatus
        }
        this.apiRequest('/wolt/toggle-location-status', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
            this.woltStatus = !this.woltStatus
          }
          this.loading = false
        })
      },
      updateWoltSchedule () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          wolt_company_id: this.location.wolt_company_id,
          schedule: this.woltSchedule
        }
        this.apiRequest('/wolt/update-schedule', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      addMoreIntervals (dayIdx) {
        this.woltSchedule[dayIdx].intervals.push({
          opening_time: null,
          closing_time: null
        })
      },
      deleteIntervals (intervalKey, dayIdx) {
        this.woltSchedule[dayIdx].intervals.splice(intervalKey, 1)
      },
      generateOnlineQr () {
        if (!this.model.id) return
        this.onlineQrLoading = true

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/table-management/' + this.model.id + '/generate-online-qr', 'POST', data, (response) => {
          this.onlineQrLoading = false
          if (response.success) {
            this.$set(this.model, 'online_qr_token', response.data.online_qr_token)
            this.$set(this.model, 'online_qr_code', response.data.online_qr_code)
          }
        })
      },
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy).then(function (e) {
          // alert('Copied')
          // console.log(e)
        }, function (e) {
          // console.log('Can not copy')
          // console.log(e)
        })
      },
      ensureBankTerminalData () {
        let data = this.model.bank_terminal_data
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data)
          } catch (e) {
            data = null
          }
        }
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
          this.$set(this.model, 'bank_terminal_data', {
            merchantId: '',
            terminalId: '',
            activationCode: ''
          })
          return
        }
        this.$set(this.model, 'bank_terminal_data', data)
        ;['merchantId', 'terminalId', 'activationCode'].forEach((key) => {
          if (typeof this.model.bank_terminal_data[key] === 'undefined' || this.model.bank_terminal_data[key] === null) {
            this.$set(this.model.bank_terminal_data, key, '')
          }
        })
      },
      normalizeBankTerminalFromResponse () {
        this.model.with_viva_wallet = !!this.model.with_viva_wallet
        if (!this.model.bank_terminal_provider) {
          this.model.bank_terminal_provider = this.model.with_viva_wallet ? 'viva_wallet' : null
        }
        this.ensureBankTerminalData()
        this.model.with_viva_wallet = this.model.bank_terminal_provider === 'viva_wallet'
      },
      onBankTerminalProviderChange () {
        const provider = this.model.bank_terminal_provider || null
        this.model.bank_terminal_provider = provider
        this.model.with_viva_wallet = provider === 'viva_wallet'
        if (provider === 'banca_transilvania') {
          this.ensureBankTerminalData()
        } else {
          this.model.bank_terminal_data = {
            merchantId: '',
            terminalId: '',
            activationCode: ''
          }
        }
      },
      setAvailableTypes () {
        const url = window.location.href.toLowerCase()

        if (url.includes('kiosk')) {
          this.type = ['Kiosk']

          // auto-select dacă vrei
          this.model.type = 'Kiosk'
          return
        }

        if (url.includes('qr')) {
          this.type = ['Masa', 'Umbrela', 'Camera']

          // dacă modelul e Kiosk, îl resetezi
          if (!this.type.includes(this.model.type)) {
            this.model.type = 'Masa'
          }

          return
        }

        // fallback default
        this.type = ['Masa', 'Umbrela', 'Camera', 'Kiosk']
      },
      getData () {
        this.loading = true
        const companyData = this.$session.get('selectedCompanyData') || {}
        const locations = Array.isArray(companyData.locations_details) ? companyData.locations_details : []
        this.locations = locations.filter(location => {
          return location && Array.isArray(location.ordering_management) &&
            location.ordering_management.some(method => method && method.type === 'self_ordering')
        })
        var data = {
          token: this.$session.get('token'),
          company_id: this.company_id
        }
        if ((this.id !== undefined && this.id !== null)) {
          this.isNew = false
        } else {
          this.isNew = true
        }
        if (!this.isNew) {
          var id = this.id || this.$route.params.id
          this.apiRequest('/table-management/' + id, 'GET', data, (response) => {
            if (response.status === true) {
              this.model = response.data
              // this.model.with_split_pay = !!this.model.with_split_pay
              // this.model.with_open_order = !!this.model.with_open_order
              this.normalizeBankTerminalFromResponse()
              this.model.pos = JSON.parse(this.model.pos)
              if (this.model.pos && Number(this.model.pos.id) === 4) {
                if (typeof this.model.pos.host === 'undefined' || this.model.pos.host === null) {
                  const fromIp = this.model.pos.ip != null && this.model.pos.ip !== '' ? String(this.model.pos.ip) : ''
                  const fromLegacy = this.model.pos.viva_terminal != null && this.model.pos.viva_terminal !== '' ? String(this.model.pos.viva_terminal) : ''
                  this.$set(this.model.pos, 'host', fromIp || fromLegacy || '')
                }
                if (typeof this.model.pos.port === 'undefined') this.$set(this.model.pos, 'port', '')
                if (typeof this.model.pos.server_ip === 'undefined') this.$set(this.model.pos, 'server_ip', '')
                if (typeof this.model.pos.server_port === 'undefined') this.$set(this.model.pos, 'server_port', '')
                if (typeof this.model.pos.tid_mid === 'undefined') this.$set(this.model.pos, 'tid_mid', '')
                if (typeof this.model.pos.ip !== 'undefined') this.$delete(this.model.pos, 'ip')
                if (typeof this.model.pos.viva_terminal !== 'undefined') this.$delete(this.model.pos, 'viva_terminal')
              }
              if (this.isOptionalServerPos) {
                if (this.model.pos.server_ip == null) this.$set(this.model.pos, 'server_ip', '')
                if (this.model.pos.server_port == null) this.$set(this.model.pos, 'server_port', '')
              }
              this.model.fiscal = JSON.parse(this.model.fiscal)
              this.model.use_fiscal_net = !!this.model.use_fiscal_net
              this.model.use_fiscal_net_with_pos = !!this.model.use_fiscal_net_with_pos
              this.model.use_pager = !!this.model.use_pager
              this.model.use_tips = !!this.model.use_tips
              this.model.use_methods = !!this.model.use_methods
              this.model.use_cash_machine = !!this.model.use_cash_machine
              this.model.disable_cash_payment = !!this.model.disable_cash_payment
              this.model.kiosk_offline = !!this.model.kiosk_offline
              this.$set(this.model, 'videos', Array.isArray(this.model.videos) ? this.model.videos : [])
              this.$set(this.model, 'qr_offline', !!this.model.qr_offline)
              this.$set(this.model, 'qr_payment_methods', this.model.qr_payment_methods || null)
              this.$set(this.model, 'login_code', this.model.login_code == null ? null : String(this.model.login_code))
              this.model.printer = JSON.parse(this.model.printer)
              if (this.model.table_colors) {
                this.model.table_colors_string = JSON.stringify(this.model.table_colors)
              }
              if (!this.model.table_shape) {
                this.model.table_shape = 'squere'
              }
              this.zone = this.model.zones
              this.$nextTick(function () {
                this.loading = false
              })
            }
          })
        } else {
          this.zone = []
          var data2 = {
            token: this.$session.get('token'),
            company_id: this.company_id
          }
          this.apiRequest('/table-zone', 'GET', data2, (response) => {
            if (response.status === true) {
              if (response.data.length) {
                for (var i = 0; i <= response.data.length - 1; i++) {
                  this.zone.push({
                    'id': response.data[i].id,
                    'name': response.data[i].name
                  })
                }
              }
              // this.zone = response.data
            }
            this.loading = false
          })
        }

        var dataFiscal = {
          token: this.$session.get('token'),
          company_id: this.company_id
        }
        this.apiRequest('/fiscal-printer', 'GET', dataFiscal, response => {
          if (response.status === true) {
            this.fiscalPrinter = response.data.fiscalPrinter
          }
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveTable() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      normalizePosForSave () {
        const p = this.model.pos
        if (!p || typeof p !== 'object' || Number(p.id) !== 4) return
        if (typeof p.host === 'undefined' || p.host === null) this.$set(this.model.pos, 'host', '')
        if (typeof p.ip !== 'undefined') this.$delete(this.model.pos, 'ip')
        if (typeof p.viva_terminal !== 'undefined') this.$delete(this.model.pos, 'viva_terminal')
      },
      // BT/UniCredit/Raiffeisen: server_ip/server_port go in the json only when filled
      posForSave (pos) {
        if (!pos || typeof pos !== 'object' || ![1, 2, 3].includes(Number(pos.id))) return pos
        const out = {...pos}
        ;['server_ip', 'server_port'].forEach(key => {
          const value = out[key] == null ? '' : String(out[key]).trim()
          if (value === '') delete out[key]
          else out[key] = value
        })
        return out
      },
      saveTable () {
        this.$nextTick(() => { this.loading = true })
        this.normalizePosForSave()
        const legacyProvider = this.model.bank_terminal_provider || (this.model.with_viva_wallet ? 'viva_wallet' : null)
        this.onBankTerminalProviderChange()
        let data = {...this.model}
        data.pos = this.posForSave(data.pos)
        if (data.bank_terminal_provider !== 'banca_transilvania') {
          data.bank_terminal_data = null
        }
        if (data.type === 'Kiosk') {
          data.ga4Code = data.ga4Code ? data.ga4Code.trim() || null : null
        } else {
          delete data.ga4Code
        }
        delete data.offline_pairing_code
        delete data.qr_pass
        if (data.type === 'Kiosk' || !data.qr_offline) delete data.login_code
        if (data.type === 'Kiosk') {
          // kiosk videos are saved by id (table_manager_videos), in display order
          data.video_ids = (data.videos || []).map(video => video.id)
        }
        delete data.videos
        if (data.type === 'Kiosk') {
          data.qr_offline = false
          delete data.qr_payment_methods
          delete data.login_code
        }
        if (data.table_colors_string) {
          data.table_colors = JSON.parse(data.table_colors_string)
        } else {
          data.table_colors = null
        }
        // Preserve the legacy provider only for NFC entries that were already selected.
        if (data.qr_payment_methods) {
          data.qr_payment_methods = JSON.parse(JSON.stringify(data.qr_payment_methods))
          ;['online', 'offline'].forEach(mode => {
            ;(data.qr_payment_methods[mode] || []).forEach(entry => {
              if (entry.type === 'POS') entry.data = null
              if (legacyProvider && entry.type === 'CARD_POS' && entry.data === null) entry.data = { bank_terminal_provider: legacyProvider }
            })
          })
        }
        data.token = this.$session.get('token')
        data.company_id = this.company_id
        this.apiRequest('/table-management/' + data.id, 'PUT', data, (response) => {
          if (response.success === true) {
            const kind = this.tableEntityKind(data.type)
            const eventName = kind === 'kiosk'
              ? 'ADMIN_KIOSK_UPDATE'
              : (kind === 'qr' ? 'ADMIN_QR_UPDATE' : 'ADMIN_TABLE_UPDATE')
            const entityId = (response.data && response.data.table && response.data.table.id) || data.id
            this.trackAdminEvent(eventName, kind, entityId, {
              [kind + '_id']: entityId,
              type: data.type || null,
              name: data.number || null,
              request: data,
              response: response
            })
            this.$nextTick(() => { this.loading = false })
            this.errors.clear()
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
            .then(() => {})
            .catch(() => {})
            this.cancelTable(response.data.table)
          } else {
            this.$nextTick(() => { this.loading = false })
            this.handleErrors(response.errors)
          }
        })
      },
      deleteTable () {
        this.$nextTick(() => { this.loadingReset = true })
        var id = this.id || this.$route.params.id
        var data = {
          company_id: this.company_id,
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/table-management/' + id, 'PUT', data, (response) => {
          if (response.success === true) {
            const kind = this.tableEntityKind(this.model && this.model.type)
            const eventName = kind === 'kiosk'
              ? 'ADMIN_KIOSK_DELETED'
              : (kind === 'qr' ? 'ADMIN_QR_DELETED' : 'ADMIN_TABLE_DELETED')
            this.trackAdminEvent(eventName, kind, id, {
              [kind + '_id']: id,
              type: (this.model && this.model.type) || null,
              name: (this.model && this.model.number) || null,
              location_id: (this.model && this.model.location_id) || null
            })
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': 'Ștergere cu succes', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.cancelTable(null, id)
          } else {
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      cancelTable (respTable, deletedTableId) {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal', 'tableModal')

        if (typeof this.callback === 'function') {
          this.callback(respTable, this.isNew, deletedTableId)
        }
      }
    }
  }
</script>
<style>
  .qr-waiter-select .el-select__tags > span > .el-tag:nth-child(n+4) {
    display: none;
  }
  .qr-waiter-select.has-overflow .el-select__tags > span::after {
    content: var(--waiter-overflow-label);
    display: inline-block;
    margin: 2px 0 2px 6px;
    padding: 0 5px;
    height: 24px;
    line-height: 22px;
    font-size: 12px;
    color: #909399;
    background: #f4f4f5;
    border: 1px solid #e9e9eb;
    border-radius: 4px;
    vertical-align: middle;
  }
  .qr-card-slot {
    width: 100%;
  }
  .qr-settings-grid {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .offline-url {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
  }
  .offline-url .form-control {
    flex: 1 1 280px;
    min-width: 0;
  }
  .offline-url .form-control[readonly] {
    background-color: #fff;
    color: #243b80;
    cursor: text;
    opacity: 1;
  }
  .offline-url .btn {
    margin: 0;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/TableManagement/TableManagementForm.vue